<template>
	<div id="app">
		<router-view></router-view>

		<OverlayModal />
	</div>
</template>

<script>
import Vue from 'vue';
import dialog from '@/mixins/dialog';

import OverlayModal from '@/components/common/OverlayModal';

Vue.mixin(dialog);

// 폰트 및 공통 CSS import
import 'remixicon/fonts/remixicon.css';
import '@/assets/css/noto-sans-kr.css';
import '@/assets/css/gmarket-sans.css';

import '@/assets/css/common.css';

export default {
	components: {
		OverlayModal,
	},
};
</script>
